import React from 'react';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';

import { IVeiculoProps } from '../../types';
import { TableButtonDelete } from './TableButtonDelete';
import { TableButtonEdit } from './TableButtonEdit';
import { TableButtonView } from './TableButtonView';
import { TableButtonRestore } from './TableButtonRestore';

interface ITableColumnControllerProps {
  handleDeleteFunction: (veiculoId: string) => Promise<void>;
  handleRestoreFunction: (veiculoId: string) => Promise<void>;
  refetch: () => void;
  dataList?: IVeiculoProps[];
}

export function TableColumnController({
  handleDeleteFunction,
  handleRestoreFunction,
  refetch,
  dataList,
}: ITableColumnControllerProps) {
  const columns: ColumnsType<IVeiculoProps> = [
    {
      title: 'Nome',
      dataIndex: 'nome',
      sorter: true,
    },
    {
      title: 'Ações',
      dataIndex: 'actions',
      render: (_, item) => {
        return (
          <div className="table-actions">
            {item.status === 0 ? (
              <TableButtonRestore handleRestoreFunction={handleRestoreFunction} contactId={String(item.id)} />
            ) : (
              <>
                <TableButtonView veiculoId={String(item.id)} refetch={refetch} data={item} />
                <TableButtonEdit veiculoId={String(item.id)} refetch={refetch} data={item} />

                <TableButtonDelete handleDeleteFunction={handleDeleteFunction} veiculoId={String(item.id)} />
              </>
            )}
          </div>
        );
      },
    },
  ];

  const data: any[] = [];

  dataList?.forEach(item => {
    data.push({
      key: item.id,
      id: item.id,
      createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
      idCidade: String(item.idCidade),
      idOperadora: String(item.idOperadora),
      grauEscola: String(item.grauEscola),
      idEsfera: String(item.idEsfera),
      nome: item.nome,
      endereco: item.endereco,
      numero: item.numero,
      bairro: item.bairro,
      complemento: item.complemento,
      cep: item.cep,
      tel1: item.tel1,
      tel2: item.tel2,
      status: item.status,
    });
  });

  return { columns, data };
}
